import React from 'react'

const Overlay = ({
  open,
  zIndex = 3000,
  backdropOpacity = 0.6
}) => {
  if (!open) return null

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex,
        backgroundColor: `rgba(0,0,0,${backdropOpacity})`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          border: '6px solid rgba(16,124,107,0.25)',
          borderTopColor: '#107c6b',
          animation: 'spin 0.9s linear infinite'
        }}
      />

      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  )
}

export default Overlay
